module.exports = __webpack_public_path__ + "static/media/005-emoji-3.b4a99b89.svg";